;(() => {
  // 当设计稿为2倍视图
  // const dpr = window.devicePixelRatio
  // const meta = document.createElement('meta')
  // eslint-disable-next-line
  // meta.setAttribute('content', `initial-scale=${1 / dpr}, maximum-scale=${1 / dpr}, minimum-scale=${1 / dpr}, user-scalable=no`)
  // meta.setAttribute('name', 'viewport')
  // const head = document.querySelector('head')
  // head.appendChild(meta)
  const htmlDom = document.querySelector('html')
  const width = window.innerWidth > 1024 ? 1024 : window.innerWidth
  htmlDom.style.fontSize = `${width / 10}px`
  // FIXME: 防抖、节流
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 1024) {
      htmlDom.style.fontSize = `${window.innerWidth / 10}px`
    }
    if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
      window.setTimeout(() => {
        document.activeElement.scrollIntoViewIfNeeded()
      }, 0)
    }
  })
})()



// WEBPACK FOOTER //
// ./src/common/winInit.js